import React from 'react';
import useMyContentPanelSharedResources, { MyContentPanelProps } from '../../useMyContentPanelSharedResources';
import { DNABox, DNADivider } from '@alucio/lux-ui';
import Header from './Header';
import Content from './Content';
import { FolderItemORM, PageGroupORM } from 'src/types/orms';
import { StyleSheet } from 'react-native';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { useMeetingsState } from 'src/state/context/Meetings/MeetingsStateProvider.proxy';
import { isPageGroupORM } from 'src/types/typeguards';

const styles = StyleSheet.create({
  content: {
    backgroundColor: colors['color-ui2-neutral-800'],
  },
})

const MeetingsVariant: React.FC<MyContentPanelProps> = (props) => {
  const { togglePresentationControlsVisibility, meetingORM } = useMeetingsState();
  const {
    selectedDocumentVersion,
    selectedTab,
    localSearchText,
    setSelectedTab,
    displayMode,
    setLocalSearchText,
    setSearchText,
    fullTextSearchEnabled,
    setFullTextSearchEnabled,
    searchText,
    setSelectedDocumentVersion,
  } = useMyContentPanelSharedResources({ ...props, meetingId: meetingORM?.model.id })

  const onPresent = (
    index: number | undefined,
    presentableORM: FolderItemORM | PageGroupORM,
  ) => {
    /** TODO: Consider whether this would be better as useEffect in the context if
     * we want this to happen universally when we select a new presentableORM */
    togglePresentationControlsVisibility()
    if (isPageGroupORM(presentableORM)) {
      props.onSelectPresentableORM?.(presentableORM, index)
    } else {
      props.onSelectPresentableORM?.(presentableORM || selectedDocumentVersion, index);
    }
  }

  return (
    <DNABox appearance="col" fill style={styles.content}>
      <DNADivider colorMode="dark"/>
      <Header
        selectedTab={selectedTab}
        localSearchText={localSearchText}
        selectedDocument={selectedDocumentVersion?.relations.documentORM}
        onSelectTab={setSelectedTab}
        displayMode={displayMode}
        setLocalSearchText={setLocalSearchText}
        setSearchText={setSearchText}
        fullTextSearchEnabled={fullTextSearchEnabled}
        setFullTextSearchEnabled={setFullTextSearchEnabled}
        sessionId={props.sessionId}
      />
      <DNADivider colorMode="dark"/>
      {selectedTab &&
        <Content
          localSearchText={localSearchText}
          searchText={searchText}
          fullTextSearchEnabled={fullTextSearchEnabled}
          selectedTab={selectedTab}
          selectedDocumentVersion={selectedDocumentVersion}
          setSelectedDocumentVersion={setSelectedDocumentVersion}
          setSelectedPage={onPresent}
          displayMode={displayMode}
          sessionId={props.sessionId}
        />
      }
    </DNABox>
  )
}

export default MeetingsVariant
